"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const sample = {
    status: {
        version: "1.0.0",
        code: 0,
        msg: "SuccessWithResult",
        total: 1,
        page: 1,
        pagesize: 10,
        transactionID: "64942aed09cea703ee2332330a883783",
        attomId: 22863980,
    },
    property: [
        {
            identifier: {
                Id: 22863980,
                fips: "42003",
                apn: "13-K-104",
                attomId: 22863980,
            },
            lot: {
                lotnum: "00104",
                lotsize1: 0.0342975,
                lotsize2: 1494,
                pooltype: "NO POOL",
            },
            area: {
                blockNum: "0013K",
                loctype: "VIEW - NONE",
                countrysecsubd: "Allegheny",
                countyuse1: "10   ",
                muncode: "AL",
                munname: "ALLEGHENY",
                subdname: "JOSEPH KEELING",
                taxcodearea: "116",
            },
            address: {
                country: "US",
                countrySubd: "PA",
                line1: "2112 ARLINGTON AVE",
                line2: "PITTSBURGH, PA 15210",
                locality: "PITTSBURGH",
                matchCode: "ExaStr",
                oneLine: "2112 ARLINGTON AVE, PITTSBURGH, PA 15210",
                postal1: "15210",
                postal2: "1922",
                postal3: "C002",
            },
            location: {
                accuracy: "Rooftop",
                latitude: "40.417522",
                longitude: "-79.976792",
                distance: 0,
                geoid: "CO42003, CS4261000, DB4219170, ND0000283400, PL4261000, SB0000113680, SB0000113705, ZI15210",
                geoIdV4: {
                    CO: "b7984f5c166838079a7a58d8eabb05a5",
                    CS: "abce5a53dd894de0a6de7360de78754d",
                    DB: "c2ca8d0c5dad26e69602a37e082160df",
                    N2: "ef988bdb9ee4524778f14842b53211c8",
                    PL: "bdf6a366a35a7778253af9fda9009a15",
                    SB: "667b453ba29ef5a982c6817305777a7c, f7c593dd98936e1e9c4cfe5c7e420c8f, 15b176febe01f1566bab629f20a2b319, 59c09a12e591858cdc57bc6989ef5d09, 2a83beea1902d577c6583d79324fb7f5, 45c4b6bfe3d7f584bfbd9d7e20bdb795, 8ce97cb400959f2e8daacb59156a8bfa, 6ccd8cfbc8c98e7eaa5467cae878878e, 67ebdc081e64461886794e382b9366df, c6a51ddb720b808b0f6f66dcce817080, bd249878832b0ae7d37903d374c90d8e, d33836f6092671e2db755912d867a1b9, 10c23da44a474a4047676279fb6c61fd, 3eaa9d18d0fff12c185161619cf102f3, e724ae6104dd36c90e3e84fba69c7a0b, bdaddb7179a01a10fdfb662641a7c3de, 34465336d715c5fc95bbfd96b05da730, b12e85cd5b58c3b730a2e6619f1410cc, 994df81ae70bac3b5fafc35e2949f887, 2e591ed6d00b11e38febd77e1fae42aa, 21c855168a439497507aac66247a7b81, bd94a12f109cd0549cdd3a71808fd71b, 0e4ee993247cc93d009cb6a7ec07a1d3, b9cfda0bd778b4074f3f433141eb2707, 65be82ec78ac2e70ff7b609b42d07a14, 64ee4e83ad46a71b14084824df104fcd, 0a34c6411519c755cae1272315c01b92, d5898d8123b00e31a7a43845737e2827, 9297c9b98795b1d2dc27f3cf78ac033c, 7a9fd2b71d72fc4d5b8206f7036dde16, 28606e8e1591828d5985e12cbce36c22, 96b847137f49d7a08489b4d5111b1114",
                    ZI: "f5fcdce20a2d7216c8924607a998a4bb",
                },
            },
            summary: {
                absenteeInd: "ABSENTEE(MAIL AND SITUS NOT =)",
                propclass: "Single Family Residence / Townhouse",
                propsubtype: "Residential",
                proptype: "SFR",
                yearbuilt: 1902,
                propertyType: "SINGLE FAMILY RESIDENCE",
                propLandUse: "SFR",
                propIndicator: "10",
                legal1: "KEELING PLAN 8 LOT 26.67XAVG112X25 RR ARLINGTON AVE 2 STY WD SDG & SHG HSE #2112",
            },
            utilities: {
                heatingtype: "CENTRAL",
            },
            building: {
                size: {
                    bldgsize: 1282,
                    grosssizeadjusted: 1282,
                    livingsize: 1282,
                    sizeInd: "LIVING SQFT",
                    universalsize: 1282,
                },
                rooms: {
                    bathsfull: 2,
                    bathstotal: 2,
                    beds: 3,
                    roomsTotal: 6,
                },
                interior: {},
                construction: {
                    condition: "FAIR",
                    constructiontype: "FRAME",
                    frameType: "WOOD",
                    roofcover: "SHINGLE                    ",
                    wallType: "OTHER (NOT CLASSIFIED)",
                },
                parking: {},
                summary: {
                    archStyle: "TRADITIONAL/OLD",
                    levels: 2,
                    quality: "FAIR",
                    view: "VIEW - NONE",
                    viewCode: "000",
                },
            },
            vintage: {
                lastModified: "2023-09-11",
                pubDate: "2023-09-11",
            },
            avm: {
                eventDate: "2023-11-20",
                amount: {
                    scr: 96,
                    value: 125574,
                    high: 130596,
                    low: 120551,
                    valueRange: 5022,
                },
                AVMChange: {
                    avmlastmonthvalue: 145665,
                    avmamountchange: -20091,
                    avmpercentchange: -14,
                },
                calculations: {
                    perSizeUnit: 97,
                    ratioTaxAmt: 209.63,
                    ratioTaxValue: 4,
                    rangePctOfValue: 8,
                },
                condition: {
                    avmpoorlow: 114523.45,
                    avmpoorhigh: 124066.2,
                    avmgoodlow: 120551,
                    avmgoodhigh: 130596,
                    avmexcellentlow: 123564.78,
                    avmexcellenthigh: 133860.9,
                },
            },
            sale: {
                salesearchdate: "2023-09-08",
                saleTransDate: "2023-08-24",
                amount: {
                    saleamt: 70000,
                    salecode: "SALE PRICE (FULL) Full sales price as per documents",
                    salerecdate: "2023-09-08",
                    saledisclosuretype: 0,
                    saledocnum: "0194240357",
                    saletranstype: "Resale",
                },
                calculation: {
                    priceperbed: 23333,
                    pricepersizeunit: 54.6,
                },
                interfamily: "N",
                resaleornewconstruction: "M",
                cashormortgagepurchase: "C",
            },
            assessment: {
                appraised: {},
                assessed: {
                    assdimprpersizeunit: 15.21,
                    assdimprvalue: 19500,
                    assdlandpersizeunit: 4.35,
                    assdlandvalue: 6500,
                    assdttlpersizeunit: 20.28,
                    assdttlvalue: 26000,
                },
                calculations: {
                    calcimprind: "ASSESSED VALUE",
                    calcimprpersizeunit: 15.21,
                    calcimprvalue: 19500,
                    calclandind: "ASSESSED VALUE",
                    calclandpersizeunit: 4.35,
                    calclandvalue: 6500,
                    calcttlind: "ASSESSED VALUE",
                    calcttlvalue: 26000,
                    calcvaluepersizeunit: 20.28,
                },
                market: {
                    mktimprvalue: 19500,
                    mktlandvalue: 6500,
                    mktttlvalue: 26000,
                },
                tax: {
                    taxamt: 599.04,
                    taxpersizeunit: 0.47,
                    taxyear: 2023,
                },
            },
        },
    ],
};
